/* global $ */

import apiRequest from 'js/common/api_request';

export async function fetchData(url, params = {}) {
  const response = await apiRequest.get(`${url}.json`, { params });
  const data = await response.data;

  return data;
}

export const syncItemWithMedia = (entryId, url) => {
  const params = {
    entry_id: entryId,
    collection_id: $('.current-collection').data('id')
  };
  apiRequest.post(`${url}.json`, params).then((response) => {
    if (response.data.sync_updates.new_title) {
      $(`[data-entry-id=${entryId}] .collection-item-title`).html(
        response.data.sync_updates.new_title
      );
    }
  });
};
